<template>
  <div>
    <Loader :show="loading"></Loader>
    <KillListTemplate :killList="killList" @go-to-game="goToGame"></KillListTemplate>
  </div>
</template>

<script>
  import KillListTemplate from '@/components/templates/KillListTemplate.vue';
  import Loader from '@/components/atoms/Loader.vue';
  import { mapState } from 'vuex';

  export default {
    components: { KillListTemplate, Loader },
    data() {
      return {
        loading: true,
      };
    },
    created() {
      this.$store.dispatch('fetchKillList').then(() => (this.loading = false));
    },
    computed: mapState({
      killList: state => state.killList,
    }),
    methods: {
      goToGame(id) {
        this.$router.push({ name: 'game', params: { id } });
      },
    },
  };
</script>
